import React from 'react';
import { Button, Card, Typography, message } from 'antd';
import logo from '../assets/primary_logo.webp';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useLogout } from '../hooks/useLogout';

const { Paragraph } = Typography;

interface ErrorPageProps {
  messageText?: string;
  showLogout?: boolean;
  showGoBack?: boolean;
  showLogin?: boolean;
  showUpgrade?: boolean;
  showMobileVerification?:boolean;
  is429Error?: boolean;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ messageText, showLogout = false, showGoBack = false, showLogin = false, showUpgrade=false, showMobileVerification = false, is429Error = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sessionMsg, setSessionMsg] = useState<string | null>(null);
  
  useEffect(() => {
    // Read and clear the error message from sessionStorage
    const msg = sessionStorage.getItem('mismatched_login_error');
    if (msg) {
      setSessionMsg(msg);
      sessionStorage.removeItem('mismatched_login_error');
    }
  }, []);
  const { logout } = useLogout();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
      message.error('Failed to logout. Please try again.');
    }
  };

  return (
    <div
      style={{
        backgroundColor: '#f0f4f9',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: 500,
          textAlign: 'center',
          borderRadius: 16,
          padding: '8px 32px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
        }}
        bordered={false}
      >
        <img
          src={logo}
          alt="FuturX Logo"
          style={{
            height: 60,
            marginBottom: 40,
            objectFit: 'contain',
          }}
        />

        <Paragraph style={{ fontSize: 16, color: '#4A4A4A', marginBottom: 32 }}>
          {sessionMsg || location.state?.messageText || messageText}
        </Paragraph>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'center' }}>
           {showUpgrade && (
            <Button
              size="large"
              onClick={()=>{navigate("/upgrade")}}
              style={{
                borderRadius: 6,
                padding: '0 32px',
                backgroundColor: "#f3f5f7ff",
                border: "1px solid #0056D2",
                color: "black",
                width: '100%',
                maxWidth: 240,
                display:"flex",
                alignItems:"center",
                justifyContent:"center"
              }}
            >
              Upgrade
            </Button>
          )}

          
          {showGoBack && (
            <Button
              type="primary"
              size="large"
              onClick={() => navigate("/")}
              style={{ borderRadius: 6, padding: '0 32px', width: '100%', maxWidth: 240 }}
            >
              Go to Home Page
            </Button>
          )}

          {showLogout && (
            <Button
              type="primary"
              size="large"
              onClick={handleLogout}
              style={{
                borderRadius: 6,
                padding: '0 32px',
                backgroundColor: "white",
                border: "1px solid #E0E0E0",
                color: "black",
                width: '100%',
                maxWidth: 240
              }}
            >
              Logout
            </Button>
          )}

          {showLogin && (
            <Button
              type="primary"
              size="large"
              onClick={handleLogout}
              style={{
                borderRadius: 6,
                padding: '0 32px',
                backgroundColor: "#0056D2",
                border: "1px solid #0056D2",
                color: "white",
                width: '100%',
                maxWidth: 240
              }}
            >
              Login
            </Button>
          )}
        </div>

      </Card>
    </div>
  );
};

export default ErrorPage;
